import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@serengeti/serengeti-common';
import { environment } from '../../../../environments/environment';
import { NavigationService } from '../../navigation/navigation.service';
import { MenuSubSideComponent } from '../toplist/subside/subside.component';

@Component({
  selector: 'app-menu-side-popup',
  templateUrl: './sidepopup.component.html',
  styleUrls: ['./sidepopup.component.scss']
})
export class SideMenuPopupComponent implements OnInit {

  @ViewChild("submenu", { static: false }) submenu: MenuSubSideComponent;

  // @Input() menus;
	_menus: any[];
	@Input() set menus(_menus: any[]) {
		if (_menus) {
			this.handleMenuVisibility(_menus);

			this._menus = _menus;
			setTimeout(() => {
				document.documentElement.style.setProperty('--documentSideMenuWidth', this.el.nativeElement.offsetWidth);
			}, 500);
		} else {
			this._menus = _menus;
		}
	}
	get menus(): any[] {
		return this._menus;
	}

  guideUrl: string;
  profile: any;

  selectedMenu: any;

  toggleMode = '';

  version: any;

  constructor(
    private router: Router,
    private loginService: LoginService,
	private el: ElementRef
  ) { 
    this.guideUrl = environment.guideUrl;
    this.profile = environment.profile;
		this.version = environment.version;
  }

  ngOnInit() {
		if (!localStorage.getItem('toggleMode')) {
			localStorage.setItem('toggleMode', 'expand');
		}
		this.toggleMode = localStorage.getItem('toggleMode');
  }

  public mouseenterSelectedMenu(menu) {
		if (this.toggleMode === 'reduction') {
			this.onSelectedMenu(menu);
		}
  }

  public clickSelectedMenu(menu) {
		if (this.toggleMode === 'expand') {
			this.onSelectedMenu(menu);
		} else {
			// The reduced sidebar used to rely solely on mouseenter, so clicking an
			// icon did nothing on touch devices and after the hover menu was closed.
			// Keep the selected menu open when its icon is clicked.
			this.selectedMenu = menu;
		}
  }
	
  public onSelectedMenu(menu) {
    if (this.selectedMenu !== menu) {
      this.selectedMenu = menu;
    } else {
      this.selectedMenu = '';
    }
  }

  public selectedMenuInit() {
		if (this.toggleMode === 'reduction') {
			this.selectedMenu = '';
		}
  }

  public selectedMenuEvent() {
		this.selectedMenuInit();
  }

  public findTopMenuFromUrl(menus: any[], url: string, topMenu: any): any {
		if (menus && menus.length > 0) {
			for (const menu of menus) {
				if (menu.menuUrl === url || url.includes(menu.menuUrl)) {
					return topMenu;
				}
			}
			for (const menu of menus) {
				if (menu.children) {
					const selectedMenu = this.findTopMenuFromUrl(menu.children, url, topMenu);

					if (selectedMenu) {
						return selectedMenu;
					}
				}
			}
		}
		return null;
	}

  handleMenuVisibility(menus: any[]) {
		menus.forEach((menu: any) => {
			if (!menu.isHandled) {
				if (this.isVisible(menu)) {
					menu.visible = 'Visible';
				} else {
					menu.visible = 'Invisible';
				}
				if (menu.children) {
					this.handleMenuVisibility(menu.children);
				}
				
				menu.defaultName = this.getMenuName(menu);
				menu.hasChildren = this.hasChildren(menu);
				menu.isHandled = true;	
			}
		});
	}

  getMenuName(menu: any) {
		let defaultName = null;
		if (menu.locales) {
			for (const locale of menu.locales) {
				if (locale.defaultState === 'Default') {
					defaultName = locale.localeName;
				}
				if (locale.code === this.loginService.getLocale()) {
					return locale.localeName;
				}
			}
		}
		return defaultName;
	}

  isVisible(menu: any): boolean {
		if (menu.visible === 'Visible') {
			if (menu.roles && environment.content && environment.content.accessRoles) {
				const roles = menu.roles.filter((role: any) => environment.content.accessRoles.includes(role.userRole));
				if (roles.length > 0) {
					for (const role of roles) {
						if (this.loginService.hasRole(role.userRole)) {
							return true;
						}
					}
					return false;	
				} else {
					return true;
				}
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

  hasChildren(menu: any): boolean {
		if (menu.children && menu.children.length > 0) {
			for (const submenu of menu.children) {
				if (submenu.visible === 'Visible') {
					return true;
				}
			}
			return false;
		} else {
			return false;
		}
	}

  public onOpenStateChanged($event: boolean) {
		this.submenu.triggerToggleState($event);
  }

  public toggleEvent() {
		window.dispatchEvent(new Event('resize'))

		if (localStorage.getItem('toggleMode') === 'expand') {
			localStorage.setItem('toggleMode', 'reduction')
		} else {
			localStorage.setItem('toggleMode', 'expand')
    }
		this.toggleMode = localStorage.getItem('toggleMode');
	
		setTimeout(() => {
			document.documentElement.style.setProperty('--documentSideMenuWidth', this.el.nativeElement.offsetWidth);
		}, 500);
  }

  public goMain() {
    this.router.navigate(['/main']);
  }

  public goGuide() {
    window.open(this.guideUrl, 'serengeti_guide');
  }

}
